import { getFixedT, useTranslation } from '@app/core/i18n';

export const I18N_NS = 'contacts-and-settings';

export const t = getFixedT(null, I18N_NS);
export const useUserSettingsTranslation = () => useTranslation(I18N_NS);
